import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { CheckCircle2 } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export function FinalCTA() {
  return <section className="w-full bg-night-900 text-white py-16 md:py-24 px-6 text-center" data-id="element-47">
      <div className="max-w-3xl mx-auto" data-id="element-48">
        <FadeIn data-id="element-49">
          <h2 className="text-3xl md:text-5xl font-serif mb-6 md:mb-8" data-id="element-50">
            Esta noche puede ser diferente.
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-51">
          <p className="text-lg md:text-xl text-slate-300 mb-4 md:mb-6 leading-relaxed" data-id="element-52">
            Cada noche que pasa con la mente acelerada es una noche de
            recuperación, energía y paz que no vuelve.
          </p>
          <p className="text-lg md:text-xl text-slate-300 mb-8 md:mb-12" data-id="element-53">
            No necesitas más información. No necesitas "pensarlo más."
            <br className="hidden md:block" data-id="element-54" />
            <span className="text-white font-medium md:ml-2" data-id="element-55">
              Necesitas un sistema. Y está aquí, ahora, por $17.
            </span>
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-56">
          <div className="flex flex-col items-center justify-center gap-2 mb-6 md:mb-8" data-id="element-57">
            <span className="text-sm md:text-base text-slate-400" data-id="element-58">
              Tu precio especial expira en:
            </span>
            <CountdownTimer className="text-2xl md:text-3xl" data-id="element-59" />
          </div>

          <Button href="https://www.viventispace.com/cart/46127430566076:1" className="w-full sm:w-auto text-lg md:text-xl px-8 md:px-12 py-4 md:py-5 mb-6 md:mb-8" data-id="element-60">
            🟣 QUIERO EMPEZAR ESTA NOCHE →
          </Button>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-8 text-xs md:text-sm text-slate-400" data-id="element-61">
            <div className="flex items-center" data-id="element-62">
              <CheckCircle2 className="w-3.5 h-3.5 md:w-4 md:h-4 text-purple-400 mr-2" data-id="element-63" />
              <span data-id="element-64">Acceso inmediato</span>
            </div>
            <div className="flex items-center" data-id="element-65">
              <CheckCircle2 className="w-3.5 h-3.5 md:w-4 md:h-4 text-purple-400 mr-2" data-id="element-66" />
              <span data-id="element-67">Garantía 7 días</span>
            </div>
            <div className="flex items-center" data-id="element-68">
              <CheckCircle2 className="w-3.5 h-3.5 md:w-4 md:h-4 text-purple-400 mr-2" data-id="element-69" />
              <span data-id="element-70">Precio de validación</span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}